<template>
  <el-dialog
    title="小A已罢工"
    class="newDialog"
    append-to-body
    :show-close="again"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="dialogVisible"
    width="500px"
    >
    <div class="AI_angry_dialog">
      <p style="color: #F56C6C;font-weight: 600;user-select: none;">你已经成功惹怒了小A，请选择你的操作：</p>
      <div class="AI_angry_dialog-footer">
        <acc-btn :text="again?'真是矫情':'熟视无睹'" type="2" @click="cancel" size="mini" width="200px" v-if="!again"></acc-btn>
        <acc-btn @click="handleEventSave" size="mini" text="这么可爱的机器人哄一哄就好了" width="200px"></acc-btn>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props:{
      again:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        dialogVisible:false,
      }
    },
    methods:{
      handleEventSave() {
        this.dialogVisible = false;
        this.$emit("success",true)
      },
      cancel() {
        this.$confirm(`此操作可能彻底惹怒小A，导致系统${this.again?'彻底崩溃':'弹框关闭'}，是否继续？`, '提示', {
          confirmButtonText: '继续关闭',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          this.dialogVisible = false;
          this.$emit("error",true);
        })
      }
    }
  }
</script>

<style lang='less'>
  .el-dialog__title {
    user-select: none;
  }
  .AI_angry_dialog {
    padding: 0 30px 30px;

    &-input {
    }
    &-footer {
      user-select: none;
      margin-top: 30px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AIImport/aiAngry.vue